import Rx from 'rx';
import {fromRxJS5} from "../app";

// Pending acknowledgements for the logged-in user, as a live feed: the
// backend's org.eggs.get_acknowledgements is a progressive call that sends
// the pending list on connect and again whenever it changes. (It used to
// be a topic the backend published to per subscriber.) If the call drops,
// because the backend restarted, come back for it after a moment.
export default function acknowledge($wamp) {

  const acknowlegements = new Rx.Subject();

  fromRxJS5($wamp.thruway.progressiveCall('org.eggs.get_acknowledgements', []))
      .map(res => res.args[0])
      .retryWhen(errors => errors.delay(3000))
      .repeatWhen(completions => completions.delay(3000))
      .subscribe(messages => acknowlegements.onNext(messages));

  return acknowlegements;
}
